import { render } from "./GlossaryUsageInfoDialogWordsColumnList.vue?vue&type=template&id=a870a598&scoped=true&ts=true"
import script from "./GlossaryUsageInfoDialogWordsColumnList.vue?vue&type=script&lang=ts"
export * from "./GlossaryUsageInfoDialogWordsColumnList.vue?vue&type=script&lang=ts"

import "./GlossaryUsageInfoDialogWordsColumnList.vue?vue&type=style&index=0&id=a870a598&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a870a598"]])

export default __exports__